(ns frontend.view.grid.fof-assets-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce fof-assets (r/cursor app-db/views [:fof-assets-grid]))
(defonce modal-state (r/cursor fof-assets [:modals]))
(defonce view-settings (r/cursor fof-assets [:view-settings]))
(defonce grid-entities (r/cursor fof-assets [:grid-entities]))
(defonce fof-asset-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor fof-assets [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor fof-assets [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor fof-assets [:schema]))
